module.exports = __webpack_public_path__ + "static/media/eigenrådig.61c4c2e1.m4a";